import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(public)/homepage/AboutSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(public)/homepage/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(public)/homepage/ProductsHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(public)/homepage/VisionSection.tsx");
